import { Modal, Box, Paper } from '@mui/material';
import style from '../../sections/@dashboard/projectSettings/ProjectSetting.module.css';

const ModalComponent = ({ openModal, handleClose, children }) => {
  return (
    <Modal
      style={{ overflow: 'scroll' }}
      className={`${style.centerContent} ${style.container}`}
      open={openModal}
      onClose={handleClose}
    >
      <>
        <Box className={`${style.boxContainer} ${style.box}`}>
          <Paper className={`${style.boxContainer} ${style.boxStyle}`}>{children}</Paper>
        </Box>
      </>
    </Modal>
  );
};

export default ModalComponent;
